export const determineIsMobile = () => {
  return window.innerWidth < 600
}